import React from 'react';
import { Box, Card, CardContent, Typography } from '@material-ui/core';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';

import useStyles from './MessageCard.style';

const MessageCard = props => {
    const classes = useStyles();

    return (
        <Card variant="outlined" className={classes.card}>
            <CardContent>
                <Box className={classes.cardTitle} component="span">
                    <span>From {props.author}</span>
                    <span>{props.date}</span>
                </Box>
                <Typography component="div" className={classes.cardBody} color="textSecondary">
                    <div className={classes.messageTitle}>{props.title}</div>
                    {props.message}
                </Typography>
                <Box className={classes.cardFooter}>
                    <CheckCircleIcon color={props.read ? 'primary' : 'disabled'} />
                </Box>
            </CardContent>
        </Card>
    );
};

MessageCard.propTypes = {

};

export default MessageCard;